<style>
  .bold-table-line input{
    font-weight: 800 !important;
  }
  .bold-table-line {
    background-color: #9a9a9a0d;
  }
</style>
<template>
  <overlay-scrollbars
    :options="{ className: 'content-container flex-column os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <section class="content large-padding">
      <div class="grid-x align-items-center">
        <div class="cell auto">
          <h2 class="no-margin">Faktura <span v-if="objekt">#{{objekt.Objektnr}}</span></h2>
          <span class="opacity-60">
            {{state.info}}
          </span>
        </div>

        <!-- Already Invoiced -->
        <div class="cell shrink" v-if="state.finished">
          <div class="grid-x grid-margin-x">
            <div class="cell shrink">
              <div class="dl-wrap align-right">
                <span class="dl dt align-right">Fakturert</span>
                <span class="dl dd align-right">{{objekt.Fakturadato | avantidate}}</span>
              </div>
            </div>
            <div class="cell shrink">
              <div class="dl-wrap">
                <span class="dl dt align-right">Betalt dato</span>
                <span class="dl dd align-right">{{objekt.Bet_dato | avantidate}}</span>
              </div>
            </div>
            <div class="cell shrink">
              <div class="dl-wrap align-right">
                <span class="dl dt align-right">Fakturanr</span>
                <span class="dl dd align-right" v-if="bilag && bilag.twentyfourseven_invoice_id && bilag.Dato > '2019-12-31'">
                  {{ bilag.twentyfourseven_invoice_id }}
                </span>
                <span class="dl dd align-right" v-else>
                  {{objekt.Salgbilagsnr || '-'}}
                </span>
              </div>
            </div>

            <div class="cell shrink" v-if="bilag && bilag.Bilagsid">
              <a v-if="isPresenceOwner && isManagement && bilag.bilagsnr_kreditnota == null" href="javascript:;" style="margin-bottom: 10px;" class="button action" @click="showCredit">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-transfer"></use></svg>
                <span>Krediter</span>
              </a>

              <span class="button-container has-popover" :class="{'popover-active': pdfPopoverActive}">
                <span class="button action glyph" @click="togglePdfPopover">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg>
                  <span>Vis faktura</span>
                </span>
                <span class="popover align-x-right align-y-bottom medium">
                  <ul>
                    <li><a href="javascript:;" @click="showBilagsPdf"><span>Vis strekkode</span></a></li>
                    <li><a href="javascript:;" @click="showBilagsEmailPdf"><span>Skriv ut / send e-post</span></a></li>
                  </ul>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="card large-padding margin-top no-margin-bottom">
        <TheLoader :active="loading" :small="true"/>

        <template v-if="!loading">
          <TheEmptyList v-if="!state.finished && !state.editableAs && !isReturnInvoice"
                        :title="'Ikke klar for fakturering...'" :large="false" :icon="'button-glyph-object'"/>
          <TheEmptyList v-else-if="!state.finished && !state.editableAs && isReturnInvoice"
                        :title="'Fakturert retur...'" :large="false" :icon="'button-glyph-object'"/>

          <template v-if="state.editableAs">
            <div class="grid-x">
              <!-- Popover -->
              <div class="cell auto">
                <span class="button-container has-popover" :class="{'popover-active': varePopoverActive}"
                      @click="toggleVarePopover()">
                  <span class="button action glyph" :class="{'disabled': !isPresenceOwner}"><svg width="16px" height="16px" viewBox="0 0 16 16"><use
                    xlink:href="/static/sprites.svg#button-glyph-add"></use></svg> <span>Ny fakturalinje</span></span>
                  <span class="popover align-x-left align-y-bottom xlarge">
                    <overlay-scrollbars
                      :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
                    <ul>
                      <li v-for="item in vareOptions.sort(sortLinevalues).filter(x => x.status)"
                          v-bind:key="'add-' + item.data.Vareid">
                        <a href="javascript:;" @click="addVare(item)" class="add-form-line popover-form-line"><span>{{item.data.Beskrivelse || item.val}} <span
                          class="label">{{item.val}}</span></span></a>
                      </li>
                    </ul>
                    </overlay-scrollbars>
                  </span>
                </span>
              </div>
              <!-- // Popover -->

              <!-- The Form things -->
              <div class="cell shrink">
                <span class="button-container has-popover" :class="{'popover-active': formPopoverActive}"
                      @click="toggleFormPopover()">
                  <span class="button action glyph" :class="{'disabled': !isPresenceOwner}"><svg width="16px" height="16px" viewBox="0 0 16 16"><use
                    xlink:href="/static/sprites.svg#button-glyph-edit"></use></svg> <span>Innstillinger</span></span>
                  <span class="popover popover-has-footer align-x-right align-y-bottom medium">
                    <ul>
                      <li :class="{'disabled': !isPresenceOwner}">
                        <TheSwitchInputPopover
                          v-model="form.Export"
                          label="Eksport"
                          labelTrue=""
                          labelFalse=""
                          trueValue="T"
                          falseValue="F"
                          :disabled="!isPresenceOwner"
                        />
                      </li>
                      <li :class="{'disabled': !isPresenceOwner || form.Export !== 'T'}">
                        <TheSwitchInputPopover
                          v-model="form.Mvafri"
                          label="Mvafri"
                          labelTrue=""
                          labelFalse=""
                          trueValue="T"
                          falseValue="F"
                          :disabled="!isPresenceOwner || form.Export !== 'T'"
                        />
                      </li>
                    </ul>
                  </span>
                </span>
              </div>
              <!-- // The Form things -->
            </div>
          </template>

          <table class="medium padding margin-top margin-bottom" v-if="state.finished || state.editableAs">
            <thead>
            <tr>
              <th>Beskrivelse</th>
              <th>Kode</th>
              <th class="align-right">Pris eks. mva</th>
              <th class="align-right">Pris inkl. mva</th>
              <th class="align-right">&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="line in bilagLines" v-bind:key="line.Internalid" v-if="shouldDisplayLine(line)" :class="{ 'bold-table-line' : line.Varetype == 'O'}">
              <td>
                <span v-if="!state.editableAs">{{line.Beskrivelse | truncate(80)}}</span>
                <div v-else class="input-container minimal no-margin large text">
                  <input type="text" v-model="line.Beskrivelse" maxlength="100" :disabled="!isPresenceOwner">
                  <span class="glyph"><svg viewBox="0 0 44 44"><use
                    xlink:href="/static/sprites.svg#button-glyph-pencil"></use></svg></span>
                </div>
              </td>
              <td>
                <span class="label">{{line.Varenr}}</span>
              </td>
              <td class="align-right">
                {{line.Belop | thousandsFloat}}
              </td>
              <td class="align-right opacity-60">
                <span v-if="!state.editableAs || !line.Internaledit">{{line.Beloptotal | thousandsFloat}}</span>
                <TheDecimalInputTable v-else
                  v-model="line.Beloptotal"
                  containerClassName="input-container minimal align-right no-margin small"
                  @blur="onValueChange($event, line)"
                  :disabled="!isPresenceOwner"/>
              </td>
              <td class="align-right">
                <a href="javascript:;" v-if="isPresenceOwner && state.editableAs && line.Internaldel" @click="delBilagLine(line)"
                   class="button action input-action glyph glyph-only no-margin">
                  <svg width="16px" height="16px" viewBox="0 0 16 16">
                    <use xlink:href="/static/sprites.svg#button-glyph-delete"></use>
                  </svg>
                </a>
              </td>
            </tr>
            </tbody>
            <tfoot class="highlight">
            <tr>
              <td colspan="2"><strong>Total</strong></td>
              <td class="align-right"><strong>{{totalPriceExc}}</strong></td>
              <td class="align-right"><strong>{{totalPriceInc}}</strong></td>
              <td>&nbsp;</td>
            </tr>
            </tfoot>
          </table>

          <div class="grid-x">
            <div class="cell auto"></div>

            <!-- Already Invoiced -->
            <div class="cell shrink" v-if="state.finished">
              <!-- Annuler -->
              <!-- Krediter -->
            </div>
            <!-- Normal invoice -->
            <div class="cell shrink" v-else-if="state.editableAs === 'normal'">
              <a v-if="isPresenceOwner && !loading" href="javascript:;" :disabled="!objekt.kontrakt.Registrertsignert" class="button primary submit large" @click="openSaveModal()">Opprett
                faktura <span v-if="!objekt.kontrakt.Registrertsignert"> (ikke signert)</span></a>
              <a v-else href="javascript:;" class="button primary submit large" disabled>Opprett faktura</a>
            </div>

            <!-- Underhandsalg -->
            <div class="cell shrink" v-else-if="state.editableAs === 'underhand'">
              <a v-if="isPresenceOwner && !loading" href="javascript:;" :disabled="!objekt.kontrakt.Registrertsignert" class="button primary submit large" @click="openSaveModal()">Opprett
                underhåndssalg<span v-if="!objekt.kontrakt.Registrertsignert"> (ikke signert)</span></a>
              <a v-else href="javascript:;" class="button primary submit large" disabled>Opprett
                underhåndssalg</a>
            </div>
          </div>
        </template>
      </div>
    </section>

    <section class="content transparent-gray flex-grow"></section>
  </overlay-scrollbars>
</template>

<script>
import ObjektService from '@/services/ObjektService'
import InstillingerService from '@/services/InstillingerService'
import bus from '@/plugins/event-bus'
import moment from 'moment'
import accounting from 'accounting-js'

const SALAR_MAP = {
  'AL': 15.3846153845,
  'BL': 15.3846153845,
  'CL': 15.3846153845,
  'DL': 15.3846153845,
  'EL': 15.3846153845,
  'UL': 20,
  'ZL': 20,
  'FL': 25,
  'GL': 25,
  'HL': 25,
  'IL': 25,
  'JL': 25,
  'KL': 25,
  'LL': 25,
  'ML': 25,
  'NL': 25,
  'OL': 25,
  'PL': 25,
  'QL': 25,
  'RL': 25,
  'SL': 25,
  'TL': 25,
  'VL': 25,
  'WL': 25,
  'XL': 25,
  'YL': 25,
  'ÆL': 25,
  'ØL': 0,
  'ÅL': 0,
  // Sentrum
  'AS': 15.3846153845,
  'BS': 15.3846153845,
  'CS': 15.3846153845,
  'DS': 15.3846153845,
  'ES': 15.3846153845,
  'US': 20,
  'ZS': 20,
  'FS': 25,
  'GS': 25,
  'HS': 25,
  'IS': 25,
  'JS': 25,
  'KS': 25,
  'LS': 25,
  'MS': 25,
  'NS': 25,
  'OS': 25,
  'PS': 25,
  'QS': 25,
  'RS': 25,
  'SS': 25,
  'TS': 25,
  'VS': 25,
  'WS': 25,
  'XS': 25,
  'YS': 25,
  'ÆS': 25,
  'ØS': 0,
  'ÅS': 0
}

const KUNST_MAPPING = [
  'AL',
  'BL',
  'CL',
  'DL',
  'EL',
  'AS',
  'BS',
  'CS',
  'DS',
  'ES'
]

export default {
  name: 'KundeKontraktObjektTabKjoperBilag',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    objekt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      bkh: true,
      processing: false,
      vareList: [],
      pdfPopoverActive: false,
      varePopoverActive: false,
      formPopoverActive: false,
      bilag: null,
      bilagLines: [],
      currentIndexCount: 0,
      isReturnInvoice: false,
      isInAuction: false,
      objektTitle: '',
      form: {
        Bilagstype: 'F',
        Retur: 'F',
        Export: 'F',
        Mvafri: 'F',
        objektdata: {
          Mottaker: this.objekt.Mottaker,
          Salgspris: this.objekt.Salgspris,
          Auksjon: null
        },
        bilaglines: []
      },
      presenceChannelName: null
    }
  },
  watch: {
    'form.objektdata.Salgspris': function (newVal) {
      if (newVal !== undefined) {
        if (this.state.editableAs === 'underhand') {
          this.recalcObjekt(true)
        }
      }
    },
    'form.Export': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.recalcAll()
      }
      if (newVal === 'F') {
        this.form.Mvafri = 'F'
      }
    },
    'form.Mvafri': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.recalcAll()
      }
    },
    objekt: function () {
      console.log('kjoper bilag objekt updated')
      this.setup()

      if (!this.isReturnInvoice) {
        this.fetchBilag()
      } else {
        this.fetchBilagAr()
      }
    }
  },
  computed: {
    state: function () {
      if (this.isReturnInvoice) {
        // Retur
        return {finished: true, editableAs: null, info: 'Fakturert i retur'}
      }
      if (this.objekt.Salgbilagsnr && this.objekt.Fakturert === 'F') {
        // Fakturert
        return {finished: true, editableAs: null, info: 'Fakturert'}
      } else if (this.objekt.Salgbilagsnr && this.bilag) {
        // Fakturert: Feil Fakturert verdi
        return {finished: true, editableAs: null, info: 'Fakturert'}
      } else if (this.objekt.Salgspris) {
        // Ikke ennå fakturert
        return {finished: false, editableAs: 'normal', info: 'Ikke fakturert'}
      } else if (!this.isInAuction) {
        // Kan faktureras i retur eller underhand
        return {finished: false, editableAs: 'underhand', info: 'Fakturer underhåndssalg'}
      } else {
        // Låst, ikke klar før fakturering eller underhand
        return {finished: false, editableAs: null, info: 'Ikke tilslag'}
      }
    },
    vareOptions: function () {
      return this.vareList.filter((i) => {
        if (i.data.Varekode === 'OBJEKT') {
          return false
        }

        if (i.data.Varekode === 'SALÆR') {
          return false
        }

        if (i.data.Varekode === 'AVRUNDING') {
          return false
        }

        if (i.data.Varekode === 'LLUKE' && this.lagerleieWeeks === null) {
          return false
        }

        if (i.data.Varekode === 'BKH') {
          return false
        }

        return !i.Used
      })
    },
    lagerleieWeeks: function () {
      // Check objekt
      if (!this.objekt.Lagerleieinfo || !this.objekt.Lagerleiedato) {
        return null
      }

      // Also check mottaker
      if (!this.objekt.mottaker || !this.objekt.mottaker.SendLagerleieinfo) {
        return null
      }

      const today = moment().format('YYYY-MM-DD')
      const ldato = moment(moment(this.objekt.Lagerleiedato).format('YYYY-MM-DD'))
      const diff = ldato.diff(today)

      // Only if today or less than today's date
      if (diff <= 0) {
        const totd = Math.abs(moment.duration(diff).as('days'))
        const totw = Math.floor(totd / 7) + ((totd % 7) > 0 ? 1 : 1)
        // weeks from object
        const weeks = this.objekt.lagerleie_weeks ? this.objekt.lagerleie_weeks : totw

        return {
          weeks: weeks,
          from: ldato.format('YYYY-MM-DD'),
          till: today
        }
      }

      return null
    },
    totalPriceInc: function () {
      let retval = 0

      this.bilagLines.forEach((line) => {
        if (line.Beloptotal !== null && line.Beloptotal !== '') {
          retval += parseFloat(line.Beloptotal)
        }
      })

      return accounting.formatNumber(retval, {precision: 2, thousand: ' '})
    },
    totalPriceExc: function () {
      let retval = 0

      this.bilagLines.forEach((line) => {
        if (line.Belop !== null && line.Belop !== '') {
          retval += parseFloat(line.Belop)
        }
      })

      return accounting.formatNumber(retval, {precision: 2, thousand: ' '})
    },
    currentSalarPris: function () {
      const index = this.bilagLines.findIndex(x => x.Varenr === 'SALÆR')

      if (index !== -1) {
        return this.bilagLines[index].Belop
      }

      return 0
    },
    currentObjektPris: function () {
      const index = this.bilagLines.findIndex(x => x.Varenr === this.objekt.Objektnr)

      if (index !== -1) {
        return this.bilagLines[index].Belop
      }

      return 0
    },
    isPresenceOwner: function () {
      return this.$store.getters['presence/isOwner'](this.presenceChannelName)
    },
    isManagement: function () {
      return this.hasAccess('management')
    }
  },
  created () {
    bus.$off('invoice-created')

    // Set name for the WS channel
    this.presenceChannelName = 'presence-objekt-edit-' + this.objekt.Objektid

    var vm = this

    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.varePopoverActive = false

        vm.formPopoverActive = false
      }
    })

    this.loading = true
    this.processing = false

    this.setup()
    this.fetch()
  },
  mounted () {
    bus.$on('invoice-created', (data) => this.onInvoiceCreated(data))
  },
  methods: {
    shouldDisplayLine: function (line) {
      // if (line.Varenr === 'BKH' && line.Beloptotal === '0.00') {
      //   return false
      // }
      // if (line.Varenr === 'SALÆR' && line.Beloptotal === '0.00') {
      //   return false
      // }
      return true
    },
    showBilagsPdf: function () {
      this.pdfPopoverActive = false
      this.openModal('bilag-pdf-modal', {bilag: this.bilag, internalWindow: true}, 'split')
    },
    showBilagsEmailPdf: function (item) {
      this.pdfPopoverActive = false
      this.openModal('bilag-email-pdf-modal', { query: this.bilag, internalWindow: true }, 'split')
    },
    onInvoiceCreated: function (data) {
      console.log('KjoperBilag::on Invoice Created')
      this.$helpers.showSuccessAlert('Faktura er lagret')

      // Update objekt
      if (data.objekt) {
        bus.$emit('kunde-kontrakt-objekt-updated', data.objekt)
      }

      // And set new bilag + bilag lines
      // this.setBilag(data.bilag)

      sessionStorage.showObjektTab = 'kjoper'
      bus.$emit('objekt-modal-reload')
    },
    openSaveModal: function () {
      if (!this.isPresenceOwner) {
        return
      }

      if (!this.objekt.kontrakt.Registrertsignert) {
        return
      }
      // Check so we have a Salgspris set.
      if (this.state.editableAs === 'underhand') {
        let found = this.bilagLines.find(x => x.Varenr === this.objekt.Objektnr)

        if (!found || found.Belop < 1) {
          this.$helpers.showErrorAlert('Feil', 'Du må angi en salgspris som er høyere enn 1')
          return
        }
      }
      this.openModal('kunde-kontrakt-objekt-tab-kjoper-bilag-modal',
        {
          data: this.form,
          state: this.state,
          lines: this.bilagLines,
          objekt: this.objekt,
          internalWindow: true
        },
        'split'
      )
    },
    setup: function () {
      // Check if is return invoice
      const m = this.objekt.Mottaker
      const i = this.objekt.Innlevav

      // Can this be enough???
      const t = this.objekt.Tilslagnr ? parseInt(this.objekt.Tilslagnr) : null
      this.isReturnInvoice = (m && i && m === i && this.objekt.Salgbilagsnr != null && t === 950)
      this.isInAuction = false

      // if (this.objekt.auksjonsdato && this.objekt.Avdelingsid !== 0) {
      //   const today = moment().format('YYYY-MM-DD')
      //   const adato = moment(moment(this.objekt.auksjonsdato).format('YYYY-MM-DD'))
      //   const diff = adato.diff(today)
      //
      //   if (diff >= 0) {
      //     this.isInAuction = true
      //   }
      // }

      // Set objekt title
      this.objektTitle = this.objekt.title + (this.objekt.subtitle ? ' / ' + this.objekt.subtitle : '')
    },
    fetch: function () {
      InstillingerService('vare').dropdownByParams({type: 'K'})
        .then((response) => {
          // Get result and add a used property
          this.vareList = response.data.map(obj => ({...obj, Used: false}))

          // Now get bilag lines
          if (!this.isReturnInvoice) {
            this.fetchBilag()
          } else {
            this.fetchBilagAr()
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    fetchBilag: function () {
      console.log('Fetch bilag')
      ObjektService.getObjektBilagBuyer(this.objekt.Objektid)
        .then((response) => {
          this.setBilag(response.data)
          if (response.data === null) {
            this.makeDefaultLines()
          }
        })
        .catch((e) => {
          // No bilag found - Make default
          console.log(e)
          this.makeDefaultLines()
        })
        .then(() => {
          this.loading = false
        })
    },
    fetchBilagAr: function () {
      ObjektService.getObjektBilagBuyerAr(this.objekt.Objektid)
        .then((response) => {
          console.log('SUCCESS')
          console.log(response)
          if (!response.data) {
            this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste in bilag')
          } else {
            this.setBilag(response.data)
          }
        })
        .catch((e) => {
          // No bilag found - Make default
          console.log('FAILED')
          console.log(e)
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste in bilag')
        })
        .then(() => {
          this.loading = false
        })
    },
    setBilag: function (data) {
      this.bilag = data
      this.bilagLines = []

      if (this.bilag && this.bilag.bilagslinje) {
        let index = -1

        this.bilag.bilagslinje.forEach((line) => {
          line.Internalid = line.Bilagslinjeid
          line.Internaltype = 'old'

          line.Beloptotal = accounting.formatNumber((line.Belop || 0) + (line.Mvabelop || 0), {precision: 2, thousand: ''})
          line.Pris = accounting.formatNumber(line.Pris || 0, {precision: 2, thousand: ''})
          line.Belop = accounting.formatNumber(line.Belop || 0, {precision: 2, thousand: ''})
          line.Mvagrunnlag = accounting.formatNumber(line.Belop || 0, {precision: 2, thousand: ''})
          line.Mvabelop = accounting.formatNumber(line.Mvabelop || 0, {precision: 2, thousand: ''})

          index = this.vareList.findIndex(x => x.data.Varekode === line.Varenr)
          if (index !== -1) {
            this.vareList[index].Used = true
          }

          this.addBilagLine(line)
        })
      }
    },
    recalcAll: function () {
      this.bilagLines.forEach(line => {
        if (line.Varenr === this.objekt.Objektnr) {
          this.recalcObjekt(false, true, line)
          // this.recalcKunstnerAvgift(line, true)
        } else if (line.Varenr === 'SALÆR') {
          this.recalcSalar(line, true)
          // this.recalcKunstnerAvgift(line, true)
        } else if (line.Varenr === 'BKH') {
          this.recalcKunstnerAvgift(line, true)
        } else {
          this.recalcLine(line, true)
        }
      })
    },
    onValueChange: function ($event, line) {
      let index = this.bilagLines.findIndex(x => x.Internalid === line.Internalid)

      if (index === -1) {
        return
      }

      if (line.Varenr === this.objekt.Objektnr) {
        this.recalcObjekt(false, false, line)
        this.recalcKunstnerAvgift(line)
      } else if (line.Varenr === 'SALÆR') {
        this.recalcSalar(line)
        this.recalcKunstnerAvgift(line)
      } else {
        this.recalcLine(line)
      }
    },
    makeDefaultLines: function () {
      // Must have a salgspris to make template bilag lines
      if (this.state.editableAs !== 'normal' && this.state.editableAs !== 'underhand') {
        return
      }

      // 1. Add Objekt
      this.addObjekt()

      // 2. Add Salar
      if (this.objekt.Avdelingsid !== 3) {
        this.addSalar()
      }

      // 3. Add Kunstnersavgift
      if (this.hasBKH()) {
        this.addKunstnersavgift(false)
      }

      // 4. Add Lagerleie
      if (this.lagerleieWeeks !== null) {
        this.addLagerleie(false)
      }
    },
    addObjekt: function () {
      const index = this.vareList.findIndex(x => x.data.Varekode === 'OBJEKT')

      if (index === -1) {
        return
      }

      const item = this.vareList[index]
      const data = {
        Antall: 1,
        Pris: this.objekt.Salgspris ? parseFloat(this.objekt.Salgspris) : 0,
        Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'O',
        Varenr: this.objekt.Objektnr,
        Beskrivelse: this.objektTitle,
        Internaldel: false,
        Internaledit: true
      }

      // Make line
      const line = this.makeVareLine(item, data)
      this.addBilagLine(line)

      // Set vare as used
      this.vareList[index].Used = true
    },
    sortLinevalues: function (a, b) {
      let aText = a.data.Beskrivelse || a.val
      let bText = b.data.Beskrivelse || b.val
      return aText.localeCompare(bText)
    },
    hasBKH: function () {
      return KUNST_MAPPING.includes(this.objekt.Kategori)
    },
    addSalar: function (sticky) {
      const index = this.vareList.findIndex(x => x.data.Varekode === 'SALÆR')

      if (index === -1) {
        return
      }

      const item = this.vareList[index]
      let Pris = parseFloat(this.objekt.Salgspris)
      if (this.currentObjektPris < 1600 && this.hasBKH()) {
        Pris = Pris * (25 / 100)
      } else if (SALAR_MAP.hasOwnProperty(this.objekt.Kategori)) {
        if (!SALAR_MAP[this.objekt.Kategori]) {
          Pris = 0
        } else if (this.hasBKH()) {
          Pris = Pris * ((SALAR_MAP[this.objekt.Kategori] * 1.25) / 100)
        } else {
          if (this.hasBKH()) {
            Pris = Pris * ((SALAR_MAP[this.objekt.Kategori] * 1.25) / 100)
          } else {
            Pris = Pris * (SALAR_MAP[this.objekt.Kategori] / 100)
          }
        }
      }

      const data = {
        Antall: 1,
        Pris: Pris,
        Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse || item.data.Varekode,
        Internaldel: false,
        Internaledit: true
      }

      // Make line
      const line = this.makeVareLine(item, data)
      this.addBilagLine(line)

      // Set vare as used
      this.vareList[index].Used = true
    },
    addKunstnersavgift: function (deletable) {
      const index = this.vareList.findIndex(x => x.data.Varekode === 'BKH')
      this.bkh = this.currentObjektPris >= 1600

      if (index === -1) {
        return
      }

      const item = this.vareList[index]
      const data = {
        Antall: 0.05,
        Pris: this.currentObjektPris >= 1600 ? parseFloat(this.currentObjektPris || 0) + parseFloat(this.currentSalarPris || 0) : 0,
        Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse || item.data.Varekode,
        Internaldel: deletable,
        Internaledit: true
      }

      // Make line
      const line = this.makeVareLine(item, data)
      this.addBilagLine(line)

      // Set vare as used
      this.vareList[index].Used = true
    },
    addLagerleie: function (deletable) {
      const index = this.vareList.findIndex(x => x.data.Varekode === 'LLUKE')

      if (index === -1) {
        return
      }

      const item = this.vareList[index]
      const data = {
        Antall: this.lagerleieWeeks.weeks,
        Pris: item.data.Pris ? parseFloat(item.data.Pris) : 0,
        Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse + ' (' + this.lagerleieWeeks.from + ' - ' + this.lagerleieWeeks.till + ')',
        Internaldel: deletable,
        Internaledit: true
      }

      // Make line
      const line = this.makeVareLine(item, data)
      this.addBilagLine(line)

      // Set vare as used
      this.vareList[index].Used = true
    },
    addVare: function (item) {
      // Find index of vare in list
      const index = this.vareList.findIndex(x => x.data.Vareid === item.data.Vareid)

      if (index === -1) {
        this.$helpers.showErrorAlert('Feil', 'Kunne ikke finne vare')
        return
      }

      if (item.data.Varekode === 'LLUKE') {
        this.addLagerleie(true)
        return
      }

      if (item.data.Varekode === 'BKH') {
        this.addKunstnersavgift(true)
        return
      }

      const data = {
        Antall: 1,
        Pris: item.data.Pris ? parseFloat(item.data.Pris) : 0,
        Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse || item.data.Varekode,
        Internaldel: true,
        Internaledit: true
      }

      // Make line
      const line = this.makeVareLine(item, data)
      this.addBilagLine(line)

      // Set vare as used
      this.vareList[index].Used = true
    },
    recalcObjekt: function (withUnderhandPrice, fullRecalc, currLine) {
      // Recalc Objekt
      let index = this.bilagLines.findIndex(x => x.Varenr === this.objekt.Objektnr)
      let vidx = null
      let item = null
      let data = null
      let line = null
      let Pris = null

      if (withUnderhandPrice) {
        // Here Salgspris has changed
        Pris = parseFloat(this.form.objektdata.Salgspris || 0)
      } else if (currLine) {
        // Ink mva has changed
        Pris = parseFloat(currLine.Beloptotal || 0)
      } else {
        // No line, hence we shall recalc with current objekt pris
        // Pris = currLine.Beloptotal
        Pris = parseFloat(this.currentObjektPris || 0)
      }

      if (index !== -1) {
        vidx = this.vareList.findIndex(x => x.data.Varekode === 'OBJEKT')
        item = this.vareList[vidx]

        let MvaProcent = this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0

        if (fullRecalc) {
          if (this.form.Export === 'T' && this.form.Mvafri === 'F' && MvaProcent === 0) {
            MvaProcent = 25
            Pris = parseFloat(this.currentObjektPris || 0) * 1.25
          } else if (this.form.Export === 'T' && this.form.Mvafri === 'T') {
            MvaProcent = 0
            Pris = parseFloat(this.currentObjektPris || 0)
          } else {
            Pris = parseFloat(this.currentObjektPris || 0)
          }
        }

        data = {
          Antall: 1,
          Pris: Pris, // withUnderhandPrice ? parseFloat(this.form.objektdata.Salgspris || 0) : parseFloat(this.currentObjektPris || 0),
          Mvapct: MvaProcent,
          Varetype: 'O',
          Varenr: this.objekt.Objektnr,
          Beskrivelse: this.bilagLines[index].Beskrivelse || this.objektTitle,
          Internaldel: false,
          Internaledit: true
        }

        // Make line
        line = this.makeVareLine(item, data, true)

        this.$set(this.bilagLines, index, Object.assign({}, this.bilagLines[index], line))
      }

      if (fullRecalc) {
        // If we are recalculating after mvafri changed, we skip the salar update here...
        return
      }

      // Now recalc salar
      index = this.bilagLines.findIndex(x => x.Varenr === 'SALÆR')

      if (index !== -1) {
        vidx = this.vareList.findIndex(x => x.data.Varekode === 'SALÆR')
        item = this.vareList[vidx]
        let Pris = parseFloat(this.currentObjektPris || 0)

        if (this.currentObjektPris < 1600 && this.hasBKH()) {
          Pris = Pris * (25 / 100)
        } else if (SALAR_MAP.hasOwnProperty(this.objekt.Kategori)) {
          if (!SALAR_MAP[this.objekt.Kategori]) {
            Pris = 0
          } else {
            if (this.hasBKH()) {
              Pris = Pris * ((SALAR_MAP[this.objekt.Kategori] * 1.25) / 100)
            } else {
              Pris = Pris * (SALAR_MAP[this.objekt.Kategori] / 100)
            }
          }
        }

        // Remove percent from salar price
        if (this.form.Mvafri === 'T') {
          // Must increase by possible MVA, as it will be reduced in the makeVareLine method.
          if (Pris > 0 && item.data.Prisinclmva === 'T' && item.data.mva && item.data.mva.Mvapct) {
            Pris = Pris / ((100 + parseInt(item.data.mva.Mvapct)) / 100)
          }
        }

        data = {
          Antall: 1,
          Pris: Pris,
          Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
          Varetype: 'V',
          Varenr: item.data.Varekode,
          Beskrivelse: this.bilagLines[index].Beskrivelse || item.data.Beskrivelse,
          Internaldel: false,
          Internaledit: true
        }

        // Make line
        line = this.makeVareLine(item, data, true)

        // Merge new data with old, and keep reactivity - hence Object assign
        this.$set(this.bilagLines, index, Object.assign({}, this.bilagLines[index], line))
      }
    },
    recalcSalar: function (currLine, mvaChanged) {
      // Now recalc salar
      const index = this.bilagLines.findIndex(x => x.Varenr === 'SALÆR')

      if (index !== -1) {
        const vidx = this.vareList.findIndex(x => x.data.Varekode === 'SALÆR')
        const item = this.vareList[vidx]
        let Pris = 0
        let MvaProcent = this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0

        if (mvaChanged) {
          let ObjecktPris = parseFloat(this.currentObjektPris || 0)
          if (this.currentObjektPris < 1600 && this.hasBKH()) {
            Pris = ObjecktPris * (25 / 100)
          } else if (SALAR_MAP.hasOwnProperty(this.objekt.Kategori)) {
            if (!SALAR_MAP[this.objekt.Kategori]) {
              Pris = 0
            } else {
              if (this.hasBKH()) {
                Pris = ObjecktPris * ((SALAR_MAP[this.objekt.Kategori] * 1.25) / 100)
              } else {
                Pris = ObjecktPris * (SALAR_MAP[this.objekt.Kategori] / 100)
              }
            }
          }

          if (this.form.Export === 'T' && this.form.Mvafri === 'T') {
            MvaProcent = 0
          }
        } else {
          Pris = currLine.Beloptotal
          // Pris = parseFloat(this.currentSalarPris || 0)
        }

        const data = {
          Antall: 1,
          Pris: Pris,
          Mvapct: MvaProcent,
          Varetype: 'V',
          Varenr: item.data.Varekode,
          Beskrivelse: this.bilagLines[index].Beskrivelse || item.data.Beskrivelse,
          Internaldel: false,
          Internaledit: true
        }

        // Make line
        const line = this.makeVareLine(item, data, true)

        // Merge new data with old, and keep reactivity - hence Object assign
        this.$set(this.bilagLines, index, Object.assign({}, this.bilagLines[index], line))
      }
    },
    recalcLine: function (currLine, mvaChanged) {
      let index = this.bilagLines.findIndex(x => x.Internalid === currLine.Internalid)

      if (index !== -1) {
        const vidx = this.vareList.findIndex(x => x.data.Varekode === currLine.Varenr)
        const item = this.vareList[vidx]
        let MvaProcent = this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0

        let Pris = 0 // mvaChanged ? parseFloat(currLine.Belop || 0) : parseFloat(currLine.Beloptotal || 0)
        if (mvaChanged) {
          // Must recalc to exclude mva
          if (this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct) {
            Pris = currLine.Pris * ((100 + parseInt(item.data.mva.Mvapct)) / 100)
          } else {
            Pris = currLine.Pris
          }
        } else {
          Pris = parseFloat(currLine.Beloptotal || 0)
        }

        const data = {
          Antall: 1,
          Pris: Pris,
          Mvapct: MvaProcent,
          Varetype: 'V',
          Varenr: item.data.Varekode,
          Beskrivelse: this.bilagLines[index].Beskrivelse || item.data.Beskrivelse,
          Internaldel: true,
          Internaledit: true
        }

        // Make line
        const line = this.makeVareLine(item, data, true)

        // Merge new data with old, and keep reactivity - hence Object assign
        this.$set(this.bilagLines, index, Object.assign({}, this.bilagLines[index], line))
      }
    },
    recalcKunstnerAvgift: function (currLine, mvaChanged) {
      const index = this.bilagLines.findIndex(x => x.Varenr === 'BKH')

      this.bkh = this.currentObjektPris >= 1600

      if (index === -1) {
        return
      }

      const vidx = this.vareList.findIndex(x => x.data.Varekode === 'BKH')
      const item = this.vareList[vidx]
      let Pris = this.currentObjektPris >= 1600 ? parseFloat(this.currentObjektPris || 0) + parseFloat(this.currentSalarPris || 0) : 0
      let MvaProcent = this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0

      if (mvaChanged) {
        // Must recalc to exclude mva
        if (this.currentObjektPris < 1600) {
          Pris = 0
        } else if (this.form.Mvafri === 'F') {
          Pris = parseFloat(this.currentObjektPris || 0) + parseFloat(this.currentSalarPris || 0)
        }

        if (this.form.Export === 'T' && this.form.Mvafri === 'F' && MvaProcent === 0) {
          MvaProcent = 25
        }
      }

      const data = {
        Antall: 0.05,
        Pris: Pris,
        Mvapct: MvaProcent,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: this.bilagLines[index].Beskrivelse || item.data.Beskrivelse,
        Internaldel: true,
        Internaledit: false
      }

      // Make line
      const line = this.makeVareLine(item, data, true)

      // Merge new data with old, and keep reactivity - hence Object assign
      this.$set(this.bilagLines, index, Object.assign({}, this.bilagLines[index], line))
    },
    makeVareLine: function (vare, data, onlyRecalc) {
      // Caclulate some values, that are common for all types
      let Pris = data.Pris || 0

      // CHANGED: Something sketchy with the !this.hasBKH(objekt)

      if (!onlyRecalc) {
        if (this.form.Mvafri === 'F') {
          if (!this.hasBKH() || vare.data.Varekode !== 'BKH') {
            // eslint-disable-next-line
            if (Pris != 0 && vare.data.Prisinclmva === 'T' && data.Mvapct) {
              Pris = Pris / ((100 + parseInt(data.Mvapct)) / 100)
            }
          }
        }
      } else {
        if (this.form.Mvafri === 'F') {
          if (!this.hasBKH() || vare.data.Varekode !== 'BKH') {
            // eslint-disable-next-line
            if (Pris != 0 && data.Mvapct) {
              Pris = Pris / ((100 + parseInt(data.Mvapct)) / 100)
            }
          }
        }
      }

      if (onlyRecalc && data.Varenr === 'SALÆR' && this.form.Mvafri === 'T') {
        let mvatemp = vare.data.mva && vare.data.mva.Mvapct ? vare.data.mva.Mvapct : 0
        Pris = Pris / ((100 + parseInt(mvatemp)) / 100)
      }

      let Mvabelop = 0
      let Belop = data.Antall * Pris

      if (onlyRecalc && data.Varenr === 'SALÆR') {
        Mvabelop = Belop * (data.Mvapct / 100)
      } else if (this.form.Mvafri === 'F' && data.Mvapct) {
        Mvabelop = Belop * (data.Mvapct / 100)
      }

      // const Mvabelop = Belop * (this.form.Mvafri === 'F' && data.Mvapct ? (data.Mvapct / 100) : 0)

      const Beloptotal = Belop + Mvabelop

      let line = {
        Antall: data.Antall,
        Pris: accounting.formatNumber(Pris, {precision: 2, thousand: ''}),
        Belop: accounting.formatNumber(Belop, {precision: 2, thousand: ''}),
        Mvagrunnlag: accounting.formatNumber(Belop, {precision: 2, thousand: ''}),
        Mvabelop: accounting.formatNumber(Mvabelop, {precision: 2, thousand: ''}),
        Beloptotal: accounting.formatNumber(Beloptotal, {precision: 2, thousand: ''}),
        Mvakode: this.form.Mvafri === 'F' ? vare.data.Mvakode : null,
        Mvapct: this.form.Mvafri === 'F' && data.Mvapct ? data.Mvapct : null,
        Mvatype: this.form.Mvafri === 'F' && vare.data.mva ? vare.data.mva.Mvatype : null,
        Beskrivelse: data.Beskrivelse,
        Bokforgruppekode: vare.data.bokforgruppe ? vare.data.bokforgruppe.Bokforgruppekode : '',
        Enhetskode: vare.data.Enhetskode,
        Vareid: vare.data.Vareid,
        Varenr: data.Varenr,
        Varetype: data.Varetype
      }

      if (!onlyRecalc) {
        line.Avgiftpct = null
        line.Bilagsid = null
        line.Bilagslinjeid = null
        line.Katalognr = null
        line.Linjenr = null
        line.Rabatbelop = null
        line.Rabatpct = null
        line.eurokurs = null
        line.Internalid = 'new-' + (this.currentIndexCount++)
        line.Internaltype = 'new'
        line.Internaldel = data.Internaldel
        line.Internaledit = data.Internaledit
        line.Gruppe = this.objekt.Kontraktnr + '-' + String(this.objekt.Lopenr).padStart(3, '0')
        line.Objektid = this.objekt.Objektid
        line.Utlevdato = this.objekt.Lev_dato
      }

      return line
    },
    addBilagLine: function (item) {
      this.bilagLines.push(item)
    },
    delBilagLine: function (item) {
      // Find line
      let index = this.bilagLines.findIndex(x => x.Internalid === item.Internalid)

      if (index === -1) {
        // Line does not exist - just do nothing...
        return
      }

      // Remove from lines
      this.bilagLines.splice(index, 1)

      // Find vare - and put it back to popover menu
      if (item.Vareid) {
        index = this.vareList.findIndex(x => x.data.Vareid === item.Vareid)

        if (index !== -1) {
          this.vareList[index].Used = false
        }
      }
    },
    toggleVarePopover: function () {
      if (!this.isPresenceOwner) {
        return
      }

      this.varePopoverActive = !this.varePopoverActive
      this.formPopoverActive = false
      this.pdfPopoverActive = false
    },
    toggleFormPopover: function () {
      if (!this.isPresenceOwner) {
        return
      }

      this.formPopoverActive = !this.formPopoverActive
      this.varePopoverActive = false
      this.pdfPopoverActive = false
    },
    togglePdfPopover: function () {
      this.pdfPopoverActive = !this.pdfPopoverActive
      this.formPopoverActive = false
      this.varePopoverActive = false
    },
    showCredit: function (item) {
      if (!this.isPresenceOwner || !this.isManagement) {
        return
      }

      this.pdfPopoverActive = false
      this.formPopoverActive = false
      this.varePopoverActive = false

      this.openModal('kreditering-bilag-modal', { kunde: this.objekt.mottaker, bilag: this.bilag, internalWindow: true })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektTabKjoperBilag.vue